import { camelToKebabCase } from './utils';
export function attribute(target, prop) {
    const con = target.constructor;
    if (!con.observedAttributes)
        con.observedAttributes = [];
    con.observedAttributes.push(camelToKebabCase(prop));
}
export function property(target, prop) {
    const con = target.constructor;
    if (!con.observedPropertys)
        con.observedPropertys = [];
    con.observedPropertys.push(prop);
}
export function emitter(target, event) {
    const con = target.constructor;
    if (!con.defineEvents)
        con.defineEvents = [];
    con.defineEvents.push(event);
}
export function adoptedStyle(style) {
    return function (cls) {
        const c = cls;
        if (!c.adoptedStyleSheets)
            c.adoptedStyleSheets = [];
        c.adoptedStyleSheets.push(style);
    };
}
export function connectStore(store) {
    // 这里的签名该怎么写？
    return function (cls) {
        const c = cls;
        if (!c.observedStores)
            c.observedStores = [];
        c.observedStores.push(store);
    };
}
export function customElement(name) {
    return function (cls) {
        customElements.define(name, cls);
    };
}
//# sourceMappingURL=decorators.js.map